export const policiesDataSelector = state => state.policiesData;
export const policiesConfigChangedSelector = state => state.policiesConfigChanged;
export const setPoliciesConfigChangedSelector = state => state.setPoliciesConfigChanged;
export const updateLocalPoliciesSelector = state => state.updateLocalPolicies;
export const policyConfigChangedSelector = state => state.policyConfigChanged;
export const setPolicyConfigChangedSelector = state => state.setPolicyConfigChanged;
export const setSelectedPolicySelector = state => state.setSelectedPolicy;
export const selectedPolicySelector = state => state.policiesData?.selectedPolicy?.local;
export const updateLocalSelectedPolicySelector = state => state.updateLocalSelectedPolicy;
export const policySnackbarSelector = state => state.policySnackbar;
export const setPolicySnackbarSelector = state => state.setPolicySnackbar;
export const clearPolicySnackbarSelector = state => state.clearPolicySnackbar;

